import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { setting } from '@/setting';
import { useOrgId } from '@/utils/hooks/useOrgId';
import { getSourceInfo } from '@/api/common';
import { reqCatch } from '@/utils/catch';
import { AUDIT_STATUS } from '@/constant/repo';
// import { useGlobalInfoStore } from '@/stores/Global';

type OrgModuleType = 'hot_pro' | 'not' | 'ach' | 'language' | 'dynamic';

export type OrgAuditStatusType = AUDIT_STATUS.PASS | AUDIT_STATUS.AUDITING | AUDIT_STATUS.REJECTED;
interface IAuditInfo {
  field: string;
  value: string;
  audit_status: OrgAuditStatusType;
}
export interface OrgInfo {
  create_ai?: boolean;
  id?: number;
  full_path?: string;
  avatar?: string;
  name?: string;
  description?: string;
  path?: string;
  email?: string;
  location?: string;
  orgId?: string;
  repoId?: string;
  visibility?: string;
  web_url?: string;
  mode?: string | number;
  readme_repo?: string;
  readme_branch?: string;
  readme_file_path?: string;
  item_type?: string;
  module_setting?: {
    group_id: string;
    modules: {
      key: string;
      type: string;
      value: string;
    }[];
  };
  my_role?: {
    access_level: number;
  };
  orgModule?: OrgModuleType[];
  audit_fields?: IAuditInfo[];
  [proName: string]: any;
}

export interface memObj {
  name: string;
  username: string;
  iam_id: string;
  avatar_url: string;
  [p: string]: any;
}

const { visitor, developer, admin, maintainer } = setting.role;
export const orgInfoStore = defineStore('globalOrgInfo', () => {
  const { orgId } = useOrgId('/');
  const orgInfo = ref<OrgInfo>({
    full_path: orgId.value
  });
  const orgUpdateTime = ref(false);
  const isFollow = ref<boolean>(false);
  const orgNameSpace = ref<string>('');
  const isCommunity = ref<boolean>(false);
  const communityUrl = ref<string>('');
  const communityactivityUrl = ref<string>('');
  const communityInfo = ref<Record<string, any>>({});
  const memList = ref<memObj[]>([]);
  const memCount = ref(0);
  const orgDevArticle = ref<Record<string, any>>({});
  const isDevLogin = ref<boolean>(false);
  const advertisementData = ref<any[]>([]);
  const articleTotal = ref<number>(0);
  const kanban_count = ref<number>(0);
  const members_count = ref<number>(0);
  const issues_count = ref<number>(0);
  const merge_requests_count = ref<number>(0);
  const fansTotal = ref<number>(0);
  const group_quota = localStorage.getItem('group_quota') || 1;
  const manageable_group_num = localStorage.getItem('manageable_group_num') || 0;
  const isCreateOrg = ref<boolean>(parseInt(group_quota as any) - parseInt(manageable_group_num as any) > 0);
  const orgPageLoading = ref<boolean>(false); // 组织加载骨架状态
  const access_level = ref<number>(0);
  const issueSettingEnable = ref<boolean>(false); // 是否展示issue增强设置

  const aiCreatable = computed(() => {
    // 是否可以创建ai项目
    return orgInfo.value?.create_ai === true;
  });

  const isPrivate = computed(() => {
    // 是否私有
    return orgInfo.value?.visibility === 'private';
  });

  const isAdmin = computed(() => {
    // return access_level?.value >= admin;
    return true;
  });

  const isDeveloper = computed(() => {
    // return access_level?.value >= developer;
    return true;
  });

  const isVisitor = computed(() => {
    // return access_level?.value >= visitor;
    return true;
  });

  const isAdminType = computed(() => {
    return access_level?.value >= admin;
  });

  const isMaintainerType = computed(() => {
    return access_level?.value >= maintainer;
  });

  const isDeveloperType = computed(() => {
    return access_level?.value >= developer;
  });

  const isVisitorType = computed(() => {
    return access_level?.value >= visitor;
  });

  const setOrgInfo = (info: OrgInfo) => {
    try {
      if (info) {
        const curInfo = {
          ...orgInfo.value,
          ...info
        };
        curInfo['email'] = curInfo?.group_extend?.email;
        curInfo['home_page'] = curInfo?.group_extend?.home_page;
        curInfo['location'] = curInfo?.group_extend?.location;
        curInfo['avatar_url1'] = curInfo?.avatar;
        curInfo['member_mgnt_mode'] = curInfo?.group_extend?.member_mgnt_mode || 3;
        if (curInfo.module_setting?.modules.find(i => i.key === 'GROUP_SHOW')) {
          curInfo['orgModule'] = curInfo.module_setting?.modules.find(i => i.key === 'GROUP_SHOW')?.value?.split(',') || [];
        }
        orgInfo.value = {
          ...curInfo
        };
      }
    } catch (error) {
      console.log('setOrgInfo error--', error);
    }
  };

  const updateOrgUpdateTime = () => {
    orgUpdateTime.value = true;
  };

  const setAccessLevel = (val: number) => {
    access_level.value = val;
  };

  const setVisibility = (val: string) => {
    orgInfo.value = {
      ...orgInfo.value,
      visibility: val
    };
  };

  const setFollow = (val?: boolean) => {
    isFollow.value = !!val;
  };

  const setNameSpace = (orgId: string) => {
    orgNameSpace.value = orgId;
  };

  const setCommunity = (val: boolean) => {
    isCommunity.value = val;
  };

  const setCommunityUrl = (param: { communityUrl: string; communityactivityUrl: string }) => {
    communityUrl.value = param.communityUrl;
    communityactivityUrl.value = param.communityactivityUrl;
  };
  const setCommunityInfo = (obj: Record<string, any>) => {
    communityInfo.value = obj;
  };

  const setOrgMember = (num: number, list: memObj[]) => {
    memCount.value = num;
    memList.value = list;
  };

  const setDevLogin = (val: boolean) => {
    isDevLogin.value = val;
  };
  const setAdvertisementData = (val: any[]) => {
    advertisementData.value = val;
  };
  const setArticleTotal = (num: number) => {
    articleTotal.value = num;
  };
  const setKanbanCount = (num: number) => {
    kanban_count.value = num;
    // const globalStore = useGlobalInfoStore();
    // globalStore.setMenuType('org');
    // globalStore.updateMenuNum('orgKanban', num);
  };
  const setMembersCount = (num: number) => {
    members_count.value = num;
    // const globalStore = useGlobalInfoStore();
    // globalStore.setMenuType('org');
    // globalStore.updateMenuNum('orgMember', num);
  };
  const setIssuesCount = (num: number) => {
    issues_count.value = num;
    // const globalStore = useGlobalInfoStore();
    // globalStore.setMenuType('org');
    // globalStore.updateMenuNum('orgIssue', num);
  };
  const setMergeRequestsCount = (num: number) => {
    merge_requests_count.value = num;
    // const globalStore = useGlobalInfoStore();
    // globalStore.setMenuType('org');
    // globalStore.updateMenuNum('orgMerge', num);
  };
  const setFansTotal = (num: number) => {
    fansTotal.value = num;
  };
  const setIsCreateOrg = (val: boolean) => {
    isCreateOrg.value = val;
  };
  const setOrgPageLoading = (val: boolean) => {
    orgPageLoading.value = val;
  };

  // 更新组织的module设置
  const setOrgModuleSetting = (moduleList) => {
    const curModuleList = orgInfo.value?.module_setting?.modules;
    if (curModuleList) {
      orgInfo.value = {
        ...orgInfo.value,
        module_setting: {
          group_id: orgInfo.value.id,
          modules: moduleList
        }
      };
    }
  };

  // 更新组织id
  const updateSourceInfo = async () => {
    if (orgInfo.value.id) return; // 若已存在id，则不调用接口
    const res = await reqCatch(getSourceInfo, { path: orgId.value });
    if (!res.error) {
      const { data } = res.data;
      orgInfo.value.id = Number(data.id); // 设置组织id
      orgInfo.value.name = data.name; // 设置组织名称
    }
  };

  const setIssueSettingEnable = (val: boolean) => {
    issueSettingEnable.value = val;
  };

  /** 是否是2025年度G-Star开源组织 */
  const isAnnualOrg = ref<boolean>(false);
  const setIsAnnualOrg = (val: boolean) => {
    isAnnualOrg.value = val;
  };

  return {
    aiCreatable,
    isPrivate,
    isAdmin,
    isDeveloper,
    isVisitor,
    isAdminType,
    isMaintainerType,
    isDeveloperType,
    isVisitorType,
    access_level,
    orgInfo,
    isFollow,
    orgNameSpace,
    isCommunity,
    communityUrl,
    communityInfo,
    communityactivityUrl,
    memList,
    memCount,
    orgDevArticle,
    advertisementData,
    isDevLogin,
    articleTotal,
    kanban_count,
    members_count,
    issues_count,
    merge_requests_count,
    fansTotal,
    isCreateOrg,
    orgPageLoading,
    orgUpdateTime,
    issueSettingEnable,
    isAnnualOrg,
    updateOrgUpdateTime,
    setOrgInfo,
    setAccessLevel,
    setVisibility,
    setFollow,
    setNameSpace,
    setCommunity,
    setCommunityUrl,
    setCommunityInfo,
    setOrgMember,
    setAdvertisementData,
    setDevLogin,
    setArticleTotal,
    setKanbanCount,
    setMembersCount,
    setIssuesCount,
    setMergeRequestsCount,
    setFansTotal,
    setIsCreateOrg,
    setOrgPageLoading,
    setOrgModuleSetting,
    setIssueSettingEnable,
    updateSourceInfo,
    setIsAnnualOrg
  };
});

if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(orgInfoStore, (import.meta as any).hot));
};
